const EFFLUENCES_CATEGORIES = [
    "Emotion",
    "Cristaux",
    "Fleurs",
    "Effluences"
]


export const calculateTotal = (content) => {
    return content.length
}

export const calculateTotalPhysique = (content) => {
    let totalPhysique = 0;
    content.forEach((item) => {
        if (item.mixture.category === 'Physique')
            totalPhysique++
    })
    return totalPhysique
}

export const calculateTotalEffluences = (content) => {
    let totalEffluences = 0;
    content.forEach((item) => {
        if (item.mixture.category === 'Effluences')
            totalEffluences++
    })
    return totalEffluences
}

export const calculateTotalOther = (content) => {
    let totalOther = 0;
    content.forEach((item) => {
        if (item.mixture.category === 'Autres')
            totalOther++
    })
    return totalOther
}

export const updateConfigurationWithNewTotal = (configuration) => {
    const total = calculateTotal(configuration.content)
    const totalPhysique = calculateTotalPhysique(configuration.content)
    const totalEffluence = calculateTotalEffluences(configuration.content)
    const totalOther = calculateTotalOther(configuration.content)
    return { ...configuration, total, totalPhysique, totalEffluence, totalOther }
}

export const formatDefaultConfigurationToAddCapsule = (configurations, name, databaseId) => {
    if (!configurations || !name) return {}
    const configurationWithTotals = updateConfigurationWithNewTotal(configurations)
    const updatedConfig = configurationWithTotals.content.map((configuration, index) => {
        return { ...configuration, capsule: { id: 0, name, databaseId } }

    })
    return { ...configurations, content: updatedConfig }
}

export const createDefaultConfiguration = () => {
    return {
        content: [],
        emotionalDisturbance: null,
        emotionalInversion: null,
        mentalDisturbance: null,
        organicInversion: null,
        maintainSymptoms: null,
        total: null,
        totalEffluence: null,
        totalPhysique: null,
        totalOther: null
    }
}

export const createDropdownOptions = (capsules) => {
    return capsules.map((capsule) => {
        return { value: capsule.id, label: capsule.name }
    })
}

export const createNameOptionsFromIndex = (index, currentName = '') => {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

    // Check if current name is a single letter
    if (currentName && currentName.length === 1 && alphabet.includes(currentName)) {
        // Find the current letter's position in the alphabet
        const currentIndex = alphabet.indexOf(currentName);

        // Get the next letter (or loop back to A if we're at Z)
        const nextIndex = (currentIndex + 1) % alphabet.length;
        return alphabet[nextIndex];
    }

    // Fall back to the original logic if not a single letter
    return `${alphabet[index % alphabet.length]}`;
}

export const getMixtureCountByCapsule = (content) => {
    // From the content array. Check how many mixtures are in each capsule.
    // To check it, we use mixture.capsule.id.
    // We return an object with the count of mixtures in each capsule.
    const mixturesCount = content.reduce((acc = 0, item) => {
        console.log(item)
        if (acc[item.capsule.name]) {
            acc[item.capsule.name]++
        } else {
            acc[item.capsule.name] = 1
        }
        return acc
    }
        , {})
    return mixturesCount
}

export const getMixtureCountByCapsuleWithoutEffluences = (content) => {

    const mixturesCount = content.reduce((acc = 0, item) => {
        const customDilutionCategories = item.dilution?.categories.flatMap(category => category.split(', ')) || []
        const hasEffluences = (EFFLUENCES_CATEGORIES.includes(item.mixture.category) || customDilutionCategories.some(category => EFFLUENCES_CATEGORIES.includes(category))) ? true : false

        // If the item is an effluence, we skip it.
        if (acc[item.capsule.name] && !hasEffluences) {
            acc[item.capsule.name]++
        } else if (!hasEffluences) {
            acc[item.capsule.name] = 1
        }
        return acc
    }
        , {})
    return mixturesCount
}